import clsx from "clsx";
import { FC, useState } from "react";

export const CheckBoxInput = ({ label, id, name, onChange, value, checked, error, helperText, classes, disabled, labelStyles, labelClasses }: ICheckBoxInput): JSX.Element => {
  const [checkedValue, setCheckedValue] = useState<boolean>(checked);

  return (
    <div className="space-x-6">
      <label className={clsx("inline-flex items-center cursor-pointer")}>
        <input
          type="checkbox"
          className={clsx(
            `cursor-pointer border border-primary-main checked:outline-white dark:checked:outline-0 focus:outline-white outline-none dark:focus:outline-none active:outline-white text-primary-main`, 
            classes
          )}
          name={name}
          id={id}
          value={value}
          checked={checkedValue}
          onChange={() => {
            setCheckedValue(!checkedValue);
            onChange(!checkedValue);
          }}
          disabled={disabled}
        />
        <span className={clsx("ml-2 text-sm font-medium text-gray-700 dark:text-darkBg-mainText", labelStyles, labelClasses)}>{label}</span>
      </label>
      <div className={clsx("text-xs text-gray-400 dark:text-darkBg-subText", { ["text-danger-main"]: error })}>{helperText}</div>
    </div>
  );
};

interface ICheckBoxInput {
  label: React.ReactNode;
  id?: string;
  name: string;
  value?: string;
  selectedValue?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (data: boolean) => void;
  error?: string;
  helperText?: string;
  classes?: string;
  labelStyles?: string;
  labelClasses?: string;
}
